"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } } function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
var _definitions = require('../definitions');
var _mergeClassName = require('../../utils/mergeClassName'); var _mergeClassName2 = _interopRequireDefault(_mergeClassName);


var _arrayTable = require('../../ui-core/arrayTable');

// @ts-ignore
var _ArrayTableRow = require('./arrayTable/ArrayTableRow'); var _ArrayTableRow2 = _interopRequireDefault(_ArrayTableRow);

const component = {
  name: 'array-table',
  components: {
    DataFormField: () => Promise.resolve().then(() => _interopRequireWildcard(require("../DataFormField"))).then(x => x.default),
    ArrayTableRow: _ArrayTableRow2.default,
  },
  data() {
    return { isMoving: false }
  },
  mixins: [_definitions.vueComponentMixin],
  methods: {
    handleMoveStart() { this.isMoving = true },
    handleMoveEnd() { this.isMoving = false },

    handleAddItem() {
      const arrayStub = this.stub 

      const newValue = arrayStub.prepareValueForChange()
      const item = arrayStub.getChildStub(newValue.length).getDefaultValue()
      newValue.push(item)

      arrayStub.setValue(newValue)
    },

    handleDeleteItem(index) {
      const arrayStub = this.stub 

      const newValue = arrayStub.prepareValueForChange()
      newValue.splice(index, 1)

      arrayStub.setValue(newValue)
    },

    handleMoveItem(opts) {
      const arrayStub = this.stub 

      const newValue = arrayStub.prepareValueForChange()
      const takenItems = newValue.splice(opts.from, 1)
      newValue.splice(opts.to, 0, ...takenItems)

      arrayStub.setValue(newValue)
    },
  },
  computed: {
    stub() {
      return this.container.stub
    },

    finalClassName() {
      const props = this.$props;
      const settings = props.uiSettings;
      return _mergeClassName2.default.call(void 0, 
        "ds-arrayTable",
        (_nullishCoalesce(settings.columns, () => ( 0))) > 1 && `ds-arrayTable-columns-${settings.columns}`,
        settings.className,
        props.ui.className,
        props.className
      );
    },

    elementSchema() { return this.stub.arrItems },

    cols() {
      const arrayStub = this.stub 
      return _arrayTable.getSafeColSettings.call(void 0, this.settings.cols, arrayStub)
    },

    hideActionCol() {
      return !!(this.readonly || this.uiSettings.disableDelete)
    },

    colSpan() {
      const settings = this.$props.uiSettings;
      const { hideActionCol, cols } = this;

      return (settings.hideNumber ? 0 : 1) + (hideActionCol ? 0 : 1) + cols.length
    },

    arrayLength() {
      return +_optionalChain([this, 'access', _ => _.editValue, 'optionalAccess', _2 => _2.length]) || 0
    },

    valueIndexes() {
      const a = new Array(this.arrayLength)
      for (let i = 0; i < a.length; i++) {
        a[i] = i
      }
      return a
    }
  },
};

exports. default = component;
 const arrayTableModule = {
  id: "arrayTable",
  component,
  settingsSchema: _arrayTable.settingsSchema,
  collapsible: true,
}; exports.arrayTableModule = arrayTableModule;

;(function(options){
  var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.collapsed
    ? _c(
        "div",
        {
          staticClass: "ds-collapsedArrayTable",
          on: {
            click: function($event) {
              return _vm.container.setCollapsed(false)
            }
          }
        },
        [_vm._v("\n  " + _vm._s(_vm.stub.getSummary()) + "\n")]
      )
    : _c(
        "table",
        {
          staticClass: "ds-arrayTable",
          class: { "is-empty": !_vm.arrayLength, "is-moving": _vm.isMoving }
        },
        [
          _c("thead", [
            _c(
              "tr",
              { staticClass: "ds-arrayTable-row" },
              [
                !_vm.uiSettings.hideNumber
                  ? _c("th", { staticClass: "ds-arrayTable-number" }, [
                      _vm._v("No.")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.cols, function(c, i) {
                  return _c(
                    "th",
                    {
                      key: i,
                      style: c.width
                        ? "min-width: " + c.width + "; width: " + c.width + ";"
                        : "",
                      attrs: { title: c.description || false }
                    },
                    [_vm._v(_vm._s(c.title))]
                  )
                }),
                _vm._v(" "),
                !_vm.hideActionCol
                  ? _c("th", { staticClass: "ds-arrayTable-operation" }, [
                      _vm._v("操作")
                    ])
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              !_vm.arrayLength
                ? _c(
                    "tr",
                    {
                      staticClass: "ds-arrayTable-row ds-arrayTable-row-empty"
                    },
                    [
                      _c("td", { attrs: { colspan: _vm.colSpan } }, [
                        _vm._v("\n        无内容\n      ")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.valueIndexes, function(index) {
                return _c("ArrayTableRow", {
                  key: index,
                  attrs: {
                    arrayStub: _vm.stub,
                    arrayUuid: _vm.inputId || _vm.stub.path,
                    cols: _vm.cols,
                    index: index,
                    readonly: _vm.readonly,
                    disableDrag: _vm.uiSettings.disableDrag,
                    disableDelete: _vm.hideActionCol,
                    hideNumber: _vm.uiSettings.hideNumber
                  },
                  on: {
                    delete: _vm.handleDeleteItem,
                    moveItem: _vm.handleMoveItem,
                    moveStart: _vm.handleMoveStart,
                    moveEnd: _vm.handleMoveEnd
                  }
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          !_vm.readonly && !_vm.uiSettings.disableAdd
            ? _c("tfoot", [
                _c(
                  "tr",
                  { staticClass: "ds-arrayTable-row ds-arrayTable-row-footer" },
                  [
                    _c("td", { attrs: { colspan: _vm.colSpan } }, [
                      _c(
                        "button",
                        {
                          staticClass: "ds-arrayTable-add",
                          attrs: { disabled: _vm.readonly },
                          on: { click: _vm.handleAddItem }
                        },
                        [_vm._v("添加" + _vm._s(_vm.elementSchema.title || ""))]
                      )
                    ])
                  ]
                )
              ])
            : _vm._e()
        ]
      )
}
var staticRenderFns = []
render._withStripped = true


  options.render = render
  options.staticRenderFns = staticRenderFns
  options._compiled = true
})(exports.default);
